import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// "Yes - Both Doors" only available for double-door types (ids 5-8)
const PassagePrep = ({ value = { value: '', label: '' }, onChange, disabled = false, selectedDoor }) => {
  const [selected, setSelected] = useState(value?.value || '');
  const isDouble = selectedDoor?.id >= 5;

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const labelMap = {
      'None':          'None',
      'YesActiveDoor': 'Yes - Active Door',
      'YesBothDoors':  'Yes - Both Doors',
    };
    setSelected(v);
    onChange({ value: v, label: labelMap[v] || v });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdPassagePrep">Passage Prep</label>
      <select id="SdPassagePrep" value={selected} onChange={handleChange} disabled={disabled}>
        <option value="None">{selected === 'None' ? 'None ✔' : 'None'}</option>
        <option value="YesActiveDoor">{selected === 'YesActiveDoor' ? 'Yes - Active Door ✔' : 'Yes - Active Door'}</option>
        {isDouble && (
          <option value="YesBothDoors">{selected === 'YesBothDoors' ? 'Yes - Both Doors ✔' : 'Yes - Both Doors'}</option>
        )}
      </select>
    </div>
  );
};

export default PassagePrep;
